export interface IScrollHelper {
	update: () => void;
	saveScrollTop: () => void;
	restoreScrollTop: () => void;
}

export function createScrollHelper(element: HTMLElement) {
	let scrollHeight = element.scrollHeight;
	let scrollTop = element.scrollTop;

	return {
		update() {
			const newScrollHeight = element.scrollHeight;
			if (newScrollHeight > scrollHeight) {
				element.scrollTop += newScrollHeight - scrollHeight;
			}
			scrollHeight = newScrollHeight;
		},
		saveScrollTop() {
			scrollTop = element.scrollTop;
		},
		restoreScrollTop() {
			element.scrollTop = scrollTop;
		},
	};
}
